@if (entry.route) {
  <a mad-sidebar-item [routerLink]="entry.route" routerLinkActive="active-sidebar-item">
    @if (sublevel === 0) {
      <mat-icon [ngStyle]="navEntryService.getMarginLeft(sublevel, 8)">{{ entry.matIcon }}</mat-icon>
    }
    <span [ngStyle]="navEntryService.getMarginLeft(sublevel, 30)"> {{ entry.i18n | translate }}</span>
  </a>
} @else {
  <!-- Entries without a route are disabled -->
  <mat-list-item [disableRipple]="true">
    <div matListItemAvatar>
      <mat-icon class="mat-mdc-list-item-avatar" [ngStyle]="navEntryService.getMarginLeft(sublevel, 8)">{{ entry.matIcon }} </mat-icon>
    </div>
    <span matListItemTitle> {{ entry.i18n | translate }}</span>
  </mat-list-item>
}
